import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { maxPriceChange, minPriceChange } from '../../actions';
import { getMaxPrice, getMinPrice } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';
import { InputNumberRange } from '../InputNumberRange';

export function PriceInput() {
  const dispatch: TThunkDispatch = useDispatch();
  const minPrice = useSelector(getMinPrice);
  const maxPrice = useSelector(getMaxPrice);

  const handlePriceChange = React.useCallback(
    (type: 'min' | 'max') => (event: React.SyntheticEvent, value: string) => {
      const map = {
        min: { handler: minPriceChange, key: 'minPrice' },
        max: { handler: maxPriceChange, key: 'maxPrice' },
      };

      dispatch(map[type].handler(Number(value) || null));
      setQueryParameter(map[type].key, value);
    },
    [dispatch],
  );

  return <InputNumberRange title="Стоимость" min={minPrice} max={maxPrice} onChange={handlePriceChange} size="M" />;
}
